<template>
  <div id="header" class="relative">
    <div class="absolute right-0 top-0 text-white font-bold">
      {{ appVersion }}
    </div>
    <BasePushNotificationToggle @subscribed="onSubscribed" />
    <div class="right-menu">
      <!-- Notification Bell -->
      <div class="notification-bell" @click="openNotificationHistory">
        <img
          src="@/assets/icons/bell.svg"
          class="logo bell-icon"
          alt="notifications"
        />
        <span v-if="pendingCount > 0" class="notification-badge">
          {{ pendingCount > 99 ? "99+" : pendingCount }}
        </span>
      </div>
      <div class="user-icon">
        <img src="@/assets/icons/user.svg" class="logo" alt="user" />
      </div>
      <div v-if="user">
        {{ user.user }}
      </div>
      <a @click="logout" class="logout-btn">
        Logout
      </a>
      <a @click="getOrders()">
        <img
          src="@/assets/icons/white-sync.svg"
          class="logo"
          alt="sync"
          :class="{ spin: sync }"
        />
      </a>
    </div>

    <!-- Notification History Panel -->
    <NotificationHistoryPanel
      :isOpen="showNotificationHistory"
      @close="showNotificationHistory = false"
      @notification-dismissed="fetchPendingCount"
    />
  </div>
</template>
<script>
import { getOrdersFromSource } from "@/api/Shipstation.js";
import NotificationHistoryPanel from "@/components/global/NotificationHistoryPanel.vue";

export default {
  name: "LoggedHeader",
  components: {
    NotificationHistoryPanel
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      sync: false,
      loading: false,
      showNotificationHistory: false,
      pendingCount: 0,
      notificationsService: null
    };
  },
  computed: {
    appVersion() {
      return this.$store.getters["general/getAppVersion"];
    },
    user() {
      return this.$store.getters["auth/currentUser"];
    }
  },
  mounted() {
    this.loadNotificationsService();
    this.initServiceWorkerListener();
    window.addEventListener("focus", this.fetchPendingCount);
  },
  beforeDestroy() {
    window.removeEventListener("focus", this.fetchPendingCount);
  },
  methods: {
    async loadNotificationsService() {
      try {
        this.notificationsService = await import(
          "@/api/NotificationsService.js"
        );
        this.fetchPendingCount();
      } catch (e) {
        console.log("Failed to load notifications service:", e);
      }
    },
    initServiceWorkerListener() {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.addEventListener("message", event => {
          // Update pending count when new notification arrives
          if (
            event.data &&
            (event.data.type === "SHOW_NOTIFICATION_MODAL" ||
              event.data.type === "NEW_NOTIFICATION")
          ) {
            this.fetchPendingCount();
          }
        });
      }
    },
    async fetchPendingCount() {
      if (!this.notificationsService) return;

      try {
        const response = await this.notificationsService.getPendingNotifications();
        if (response.status === "success") {
          this.pendingCount = response.count || 0;
        }
      } catch (e) {
        console.log("Failed to fetch pending count:", e);
      }
    },
    openNotificationHistory() {
      this.showNotificationHistory = true;
    },
    logout() {
      this.$store.dispatch("auth/logOut");
      this.$router.push("/");
    },
    onSubscribed() {
      this.$toast.open({
        message: "Push notifications enabled!",
        type: "success",
        position: "top-right"
      });
    },
    getOrders() {
      if (!this.sync) {
        this.sync = true;
        getOrdersFromSource().then(res => {
          if (res) {
            this.sync = false;
            this.$toast.open({
              message: res?.message || "Request Completed",
              type: res.status,
              position: "top-right"
            });
          }
        });
      }
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/style/css/generic-variables.scss";
#header {
  width: 100%;
  height: $headerHeight;
  box-shadow: inset 0 0 5px 2px rgba(0, 0, 0, 0.37);
  background-color: $headerBackground;
  color: $headerFontColor;
  padding: 0px 50px;
  display: flex;
  flex-direction: row;
  align-content: flex-end;
  justify-content: flex-end;
  .right-menu {
    display: flex;
    flex-direction: row;
    height: 100%;
    div,
    a {
      display: flex;
      padding: 0 15px;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      .logo {
        width: 25px;
        height: 25px;
      }
      .spin {
        -webkit-animation: spin 3s linear infinite;
        -moz-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
      }
      @-moz-keyframes spin {
        100% {
          -moz-transform: rotate(360deg);
        }
      }
      @-webkit-keyframes spin {
        100% {
          -webkit-transform: rotate(360deg);
        }
      }
      @keyframes spin {
        100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
      }
    }
    .notification-bell {
      position: relative;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      .bell-icon {
        filter: brightness(0) invert(1);
      }
      .notification-badge {
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-80%);
        background-color: #ef4444;
        color: white;
        font-size: 10px;
        font-weight: bold;
        min-width: 18px;
        height: 18px;
        border-radius: 9px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }
    }
  }
}
</style>
